/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Confirm_TitleInputs */

const en_embed_captions_confirm_title = /** @type {(inputs: Embed_Captions_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed Job Confirmation`)
};

const fr_embed_captions_confirm_title = /** @type {(inputs: Embed_Captions_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmation de tache d'incrustation`)
};

const de_embed_captions_confirm_title = /** @type {(inputs: Embed_Captions_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auftragsbestätigung einbetten`)
};

const it_embed_captions_confirm_title = /** @type {(inputs: Embed_Captions_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpora conferma lavoro`)
};

const ru_embed_captions_confirm_title = /** @type {(inputs: Embed_Captions_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встроить подтверждение задания`)
};

const es_embed_captions_confirm_title = /** @type {(inputs: Embed_Captions_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmación de trabajo incrustada`)
};

const zh_cn2_embed_captions_confirm_title = /** @type {(inputs: Embed_Captions_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`嵌入式工作确认`)
};

const ja_embed_captions_confirm_title = /** @type {(inputs: Embed_Captions_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`求人確認を埋め込む`)
};

const hi_embed_captions_confirm_title = /** @type {(inputs: Embed_Captions_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नौकरी की पुष्टि को एम्बेड करें`)
};

const pt_pt2_embed_captions_confirm_title = /** @type {(inputs: Embed_Captions_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporar Confirmação de Trabalho`)
};

/**
* | output |
* | --- |
* | "Embed Job Confirmation" |
*
* @param {Embed_Captions_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_confirm_title = /** @type {((inputs?: Embed_Captions_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Confirm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_confirm_title(inputs)
	if (locale === "de") return de_embed_captions_confirm_title(inputs)
	if (locale === "it") return it_embed_captions_confirm_title(inputs)
	if (locale === "ru") return ru_embed_captions_confirm_title(inputs)
	if (locale === "es") return es_embed_captions_confirm_title(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_confirm_title(inputs)
	if (locale === "ja") return ja_embed_captions_confirm_title(inputs)
	if (locale === "hi") return hi_embed_captions_confirm_title(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_confirm_title(inputs)
	return en_embed_captions_confirm_title(inputs)
});